import { useEffect, type ReactNode } from 'react'

import { useAuth } from 'src/auth'
import { EvieTopBar } from 'src/components/Evie/EvieTopBar'
import EvieUiShell from 'src/layouts/EvieUiShell'

import './applicant-navigation.css'

/** Shared applicant navigation survives both Eve and Evie. Document scrolling
 * and light applicant chrome belong here; pages own their content only. */
const ApplicantNavigationLayout = ({ children }: { children: ReactNode }) => {
  const { currentUser } = useAuth()
  useEffect(() => {
    if (currentUser) window.Intercom('update', { hide_default_launcher: true })
  }, [currentUser])
  return (
    <EvieUiShell>
      <EvieTopBar />
      <main className="applicant-navigation-main">{children}</main>
    </EvieUiShell>
  )
}

export default ApplicantNavigationLayout
